import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Space, Spin, Form, Input, Select, Row, Col, Checkbox, Tag, Tooltip, Button, Divider, Modal, Typography, Radio, notification } from 'antd';

const { Text } = Typography;

import { ExclamationCircleOutlined } from '@ant-design/icons';
import InputMask from '../InputMask/inputMask';
import icons from '../../../../../../shared/utils/files/antIcons';

import { getTinyMCEEditorTheme, isGuid, renderNoDataOrSpinner } from '../../../../../../shared/utils';

import FieldSettingsModal from './rabbit-sign-field-settings-modal/index';

import PhoneBookModal from './phone-book-modal';
import './send-file-form.less';

import api from '../../../../s3-connector/api';

import * as rabbitActions from '../../../../../../shared/store/actions/rabbit-sign-actions';
import * as smsActions from '../../../../../smses/store/actions';

import { hot } from 'react-hot-loader/root';
import withErrorHandler from '../../../../../../hoc/withErrorHandler';
import axios from '../../../../../../shared/axios/axios';
import newAxios from '../../../../../../shared/axios/new-api-axios';

import { getSignerColor } from '../../../../../../shared/utils/rabbitSign/rabbit-sign-helper';

import { cloneDeep, isArray, isEmpty, isString, orderBy } from 'lodash';
import CoverPageComponent from '../../../../../cover-page';
import SelectedFilesList from '../../../../../selected-files-list';

let root;
const SendFileForm = (props) => {
  const {
    rootContainer,
    onHide,
    inlineRenderMode,
    receiptId,
    insuredId,
    receiptIsCustomerAccountStatement,
    selectedFiles,
    onSubmit,
    sendFormCallback,
  } = props;

  const [loading, setLoading] = useState(true);
  const [sendFileInfo, setSendFileInfo] = useState({});
  const [sendToSignServiceCheckedFirstTime, setSendToSignServiceCheckedFirstTime] = useState(false);
  const [showEmailControls, setShowEmailControls] = useState(true);
  const [showEmailControlsForFormstack, setShowEmailControlsForFormstack] = useState(false);
  const [showEmailControlsForWeSign, setShowEmailControlsForWeSign] = useState(false);
  const [showEmailControlsForRabbitSign, setShowEmailControlsForRabbitSign] = useState(false);
  const [showRabbitSignSettings, setShowRabbitSignSettings] = useState(false);
  const [enabledTemplates, setEnabledTemplates] = useState(false);
  const [rabbitSignFieldSettings, setRabbitSignFieldSettings] = useState([]);
  const [rabbitSigners, setRabbitSigners] = useState([]);
  const [showFaxControls, setShowFaxControls] = useState(false);
  const [showCoverPageControls, setShowCoverPageControls] = useState(false);
  const [showCcControls, setShowCcControls] = useState(false);
  const [showBccControls, setShowBccControls] = useState(false);
  const [includePaymentSystemLinkCurrent, setIncludePaymentSystemLinkCurrent] = useState(null);
  const [messageEditorLoading, setMessageEditorLoading] = useState(true);
  const [combinedFileName, setCombinedFileName] = useState('');
  const [isMounted, setIsMounted] = useState(false);
  const [isSendFormBtnFromOutside, setIsSendFormBtnFromOutside] = useState(false);
  const [isSendAsSmsApplied, setIsSendAsSmsApplied] = useState(false);
  const [localSelectedFiles, setLocalSelectedFiles] = useState(selectedFiles || []);

  const [sendFileFromRef] = Form.useForm();

  const { validateRabbitSignSubscriptionLoading } = useSelector((state) => state.rabbitSign);

  const messageControlParameters = useSelector((state) => state.smses.messageControlParameters);
  const messageControlParametersLoading = useSelector((state) => state.smses.messageControlParametersLoading);

  const contactPhones = useSelector((state) => state.smses.contactPhones);
  const contactPhonesLoading = useSelector((state) => state.smses.contactPhonesLoading);

  const dispatch = useDispatch();

  const mceEditorId = `sendFilesMessageEditor`;

  useEffect(() => {
    root = rootContainer;

    if (!isMounted) {
      setLoading(true);

      api
        .getSendFileInfo()
        .then((fileInfo) => {
          setLoading(false);
          setIsMounted(true);

          const newFileInfo = cloneDeep(fileInfo);
          setSendFileInfo(newFileInfo);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
          setIsMounted(false);
        });
    }

    return () => {
      destroyMessageEditor();
      setRabbitSigners([]);
      setSendFileInfo({});
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(sendFileInfo) && isMounted) {
      initializeMessageEditor();
      setIsSendFormBtnFromOutside(setSendFormCallback());

      let signerFrom = null;

      if (sendFileInfo.subject) {
        sendFileFromRef.setFieldsValue({
          subject: sendFileInfo.subject,
        });
      }

      if (sendFileInfo.mainFromEmail) {
        sendFileFromRef.setFieldsValue({
          from: sendFileInfo.mainFromEmail,
        });

        signerFrom = sendFileInfo.emails.find((element) => element.email === sendFileInfo.mainFromEmail);

        if (signerFrom) {
          signerFrom.signingOrder = 1;
          signerFrom.nonRequiredToSign = true;
        } else {
          signerFrom = {
            email: sendFileInfo.mainFromEmail,
            active: true,
            contactType: 0,
            nonRequiredToSign: true,
            signingOrder: 1,
          };
        }
      }

      let mainEmail = null;

      if (sendFileInfo.mainToEmail) {
        sendFileFromRef.setFieldsValue({
          emailAddresses: [sendFileInfo.mainToEmail],
        });

        //should be in array always
        mainEmail = sendFileInfo.emails.find((element) => element.email === sendFileInfo.mainToEmail);
        if (mainEmail) {
          mainEmail.signingOrder = 1;
        }
      }

      if (signerFrom || mainEmail) {
        const arr = [];

        if (signerFrom && mainEmail && signerFrom.email == mainEmail.email) {
          arr.push(signerFrom);
        } else {
          if (signerFrom) {
            arr.push(signerFrom);
          }

          if (mainEmail) {
            arr.push(mainEmail);
          }
        }

        setRabbitSigners(arr);
      }
    }
  }, [sendFileInfo]);

  useEffect(() => {
    if (selectedFiles && selectedFiles.length) {
      setLocalSelectedFiles(selectedFiles);
    }
  }, [selectedFiles]);

  const destroyMessageEditor = () => {
    const editor = tinymce.get(mceEditorId);

    if (editor) {
      try {
        editor.remove();
      } catch (e) {
        console.log(e);
      }
    }
  };

  const changeSubject = (templateSubject) => {
    sendFileFromRef.setFieldsValue({
      subject: templateSubject,
    });
  };

  const initializeMessageEditor = () => {
    setMessageEditorLoading(true);

    tinymce.init({
      selector: `div#${mceEditorId}`,
      deprecation_warnings: false,
      auto_focus: mceEditorId,
      browser_spellcheck: true,
      max_height: 250,
      min_height: 250,
      ...getTinyMCEEditorTheme(),
      init_instance_callback: (editor) => {
        setMessageEditorLoading(false);
      },
      menubar: false,
      statusbar: false,
      forced_root_block: false,
      nc_templates_fetch_template_items: async (editorContent) => {
        if (sendFileInfo?.messageTemplates?.length) {
          return sendFileInfo.messageTemplates.map((template) => {
            return {
              text: template.name,
              value: `${editorContent !== '' ? '<br/>' : ''}${template.body}`,
              subject: template.subject,
            };
          });
        }

        return [];
      },
      nc_templates_on_before_item_apply: (messageBody, templateSubject) => {
        return new Promise((resolve, reject) => {
          const searchPatterns = ['{Insured.', '{InsuranceAgency.', '{Agent.', '{CSR.', '{Policy.', '{Util.'];

          const containsPattern = (text) => typeof text === 'string' && searchPatterns.some((pattern) => text.includes(pattern));

          if (containsPattern(messageBody) || containsPattern(templateSubject)) {
            Modal.confirm({
              getContainer: rootContainer,
              title: 'Replace Placeholders',
              icon: <ExclamationCircleOutlined />,
              content: (
                <div>The selected template contains placeholders. Do you want to replace the possible ones? (This may take a few seconds.)</div>
              ),
              okText: 'Yes',
              cancelText: 'No',
              onOk: async () => {
                const splitDelimiter = '#body#subject#';

                if (templateSubject) {
                  const messageBodyWithSubject = messageBody + splitDelimiter + templateSubject;

                  await api.replaceMessagePlaceholders(messageBodyWithSubject).then((result) => {
                    const msgs = result.split(splitDelimiter);

                    if (msgs.length === 2) {
                      changeSubject(msgs[1]);
                      messageBody = msgs[0];
                    }

                    resolve(messageBody);
                  });
                } else {
                  resolve(await api.replaceMessagePlaceholders(messageBody));
                }
              },
              onCancel: () => {
                resolve(messageBody);
              },
            });
          } else {
            resolve(messageBody);
          }
        });
      },
      plugins: 'nc-templates lists advlist code',
      toolbar_mode: 'sliding',
      toolbar:
        'undo redo | nc-templates | fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor |\
         alignleft aligncenter alignright |\
         outdent indent | bullist numlist | code',
    });
  };

  const getSelectFromEmailOptions = () => {
    if (sendFileInfo.fromEmails && sendFileInfo.fromEmails.length) {
      return sendFileInfo.fromEmails.map((email, index) => (
        <Select.Option key={index} value={email}>
          {email}
        </Select.Option>
      ));
    }

    return null;
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const color = /\S+@\S+\.\S+/.test(value) ? 'default' : 'error';
    return (
      <Tag color={color} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
        {label}
      </Tag>
    );
  };

  const handleToEmailChange = (items) => {
    sendFileFromRef.setFieldsValue({
      emailAddresses: items ? items : '',
    });

    setRabbitSignersFromArray(items);

    clearRabbitSignFieldSettings();
  };

  const handleFromEmailChange = (email) => {
    const requiredSigners = cloneDeep(rabbitSigners.filter((element) => !element.nonRequiredToSign)) || [];

    if (!isEmpty(email)) {
      const newSigner = { email: email, active: true, contactType: 0, nonRequiredToSign: true, signingOrder: 1 };
      requiredSigners.push(newSigner);
    }

    setRabbitSigners(requiredSigners);
    clearRabbitSignFieldSettings();
  };

  const setRabbitSignersFromArray = (items) => {
    const newSigners = rabbitSigners.filter((element) => element.nonRequiredToSign);

    if (items && items.length) {
      items.forEach((email) => {
        const found = sendFileInfo?.emails?.find((element) => element.email == email);

        if (found) {
          newSigners.push({ ...found, signingOrder: 1 });
        } else {
          newSigners.push({ email: email, signingOrder: 1 });
        }
      });

      setRabbitSigners(newSigners);
    } else {
      //store always email 'from' elements for rabbit sign
      const excluded = newSigners.filter((element) => element.nonRequiredToSign);

      setRabbitSigners(excluded);
    }
  };

  const submitFormData = (values) => {
    const { receiptId, receiptIsCustomerAccountStatement, isReceipt, isStatement, isInsuredSummary } = props;

    const formData = { ...values };

    const editor = tinymce.get(mceEditorId);
    const messageText = editor.save();

    if (isArray(rabbitSignFieldSettings) && !isEmpty(rabbitSignFieldSettings)) {
      rabbitSignFieldSettings.forEach(function (part, index, theArray) {
        theArray[index].imgSrc = undefined;
      });
    }

    const rabbitSignOrderedSigners = {};
    if (rabbitSigners?.length) {
      rabbitSigners.forEach((val, i) => {
        rabbitSignOrderedSigners[val.email] = val.signingOrder;
      });
    }

    try {
      if (formData.sendSms) {
        setLoading(true);

        const sendSmsModel = {
          smsServiceType: messageControlParameters.smsServiceType,
          toPhoneNumber: formData.insuredsPhone,
          myNumber: messageControlParameters.myNumber,
          toPhoneNumberName: formData.insuredsPhone,
          textMessage: messageText ? messageText.trim() : '',
          attachedPhotos: [],
          smsChatId: null,
          truckingCompanyId: window['ncFileManager']['insuredId'],
          phoneGroupSmsServiceType: messageControlParameters.phoneGroupSmsServiceType,
          phoneGroupId: messageControlParameters.phoneGroupId,
          putSmsTemplate: true,
          createNote: true,

          attachedNCFiles: localSelectedFiles
            .filter((f) => f.type === 'file' && isGuid(f.id))
            .map((f) => {
              return { id: f.id, fileName: f.name };
            }),
          combineAllPdfsIntoOne: formData.combineAllPdfsIntoOne,
          combinedFileName: combinedFileName,
        };

        dispatch(smsActions.sendMessage(sendSmsModel)).finally(() => {
          Modal.success({
            getContainer: rootContainer,
            title: 'Success',
            content: 'SMS sent successfully',
          });

          if (
            !showEmailControlsForFormstack &&
            !showEmailControlsForWeSign &&
            !showEmailControlsForRabbitSign &&
            !showEmailControls &&
            !showFaxControls &&
            formData.sendSms
          ) {
            if (typeof onSubmit === 'function') {
              onSubmit();
            }

            clearForm();

            setLoading(false);
          }
        });
      }
    } catch (error) {
      console.error(error);
      Modal.error({
        getContainer: rootContainer,
        title: 'Error',
        content: 'Send SMS error',
      });
    }

    if (
      !showEmailControlsForFormstack &&
      !showEmailControlsForWeSign &&
      !showEmailControlsForRabbitSign &&
      !showEmailControls &&
      !showFaxControls &&
      formData.sendSms
    ) {
      return;
    }

    const sendFileModel = {
      sendEmail: formData.isSendEmailChecked,
      fileIds: localSelectedFiles
        .filter((f) => f.type === 'file')
        .map((f) => {
          return { id: f.id, order: f.order };
        }),
      insuredId: window['ncFileManager']['insuredId'],
      cc: showCcControls ? formData.cc : undefined,
      fromEmail: formData.from,
      subject: formData.subject,
      messageBody: messageText ? messageText.replace(/(?:\r\n|\r|\n)/g, '<br>') : '',
      sendFax: formData.isSendFaxChecked,
      fax: formData.isSendFaxChecked ? formData.fax : undefined,
      isAddCoverPageChecked: formData.isAddCoverPageChecked,
      insuranceAgencyId: sendFileInfo.insuranceAgencyId,
      selectedEmails: formData.emailAddresses,
      bcc: showBccControls ? formData.bcc : undefined,
      isSendCcToMe: formData.isSendCcToMe,

      isFormStackChecked: sendFileInfo.canUseFormStack ? formData.isFormStackChecked : false,
      isWeSignChecked: sendFileInfo.canUseWeSign ? formData.isWeSignChecked : false,
      weSignSigType: formData.weSignSigType,
      isRabbitSignChecked: formData.isRabbitSignChecked,
      rabbitSignFieldSettings: rabbitSignFieldSettings,
      rabbitSignOrderedSigners: rabbitSignOrderedSigners,

      combineAllPdfsIntoOne: formData.combineAllPdfsIntoOne,
      combinedFileName: combinedFileName,

      receiptId: receiptId,
      receiptIsCustomerAccountStatement: receiptIsCustomerAccountStatement,
      includeIntegrityLink: receiptId ? formData.includePaymentSystemLink === 'includeIntegrityLink' : false,
      includeEPayPolicyLink: receiptId ? formData.includePaymentSystemLink === 'includeEPayPolicyLink' : false,
      includeSimplyEasierPaymentsLink: receiptId ? formData.includePaymentSystemLink === 'includeSimplyEasierPaymentsLink' : false,
      includeTranzPayPaymentsLink: receiptId ? formData.includePaymentSystemLink === 'includeTranzPayPaymentsLink' : false,
      includePayPalLink: receiptId ? formData.includePaymentSystemLink === 'includePayPalLink' : false,
      includeInput1PaymentLink: receiptId ? formData.includePaymentSystemLink === 'includeInput1PaymentLink' : false,
      includeAscendPaymentLink: receiptId ? formData.includePaymentSystemLink === 'includeAscendPaymentLink' : false,
      includeAgavePaymentLink: receiptId ? formData.includePaymentSystemLink === 'includeAgavePaymentLink' : false,
      isReceipt: isReceipt,
      isStatement: isStatement,
      isInsuredSummary: isInsuredSummary,

      coverPage: formData.coverPage,
    };

    setLoading(true);

    api
      .sendFile(sendFileModel)
      .then((res) => {
        setLoading(false);

        if (typeof onSubmit === 'function') {
          onSubmit();
        }

        const fileSendResponse = res.data;
        let noOfFilesSend = 1;
        if (fileSendResponse) {
          Modal.info({
            getContainer: rootContainer,
            title: 'Results of file send operation',
            content: (
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                {fileSendResponse.sentToEmail ? (
                  <Space size="small" direction="vertical" style={{ marginBottom: '10px' }}>
                    {fileSendResponse.sentToEmailResponseMessages.map((mes, index) => (
                      <Text key={'sentToEmail' + index} type={mes.isSuccess ? 'success' : 'danger'}>
                        {mes.message}
                      </Text>
                    ))}
                  </Space>
                ) : null}

                {fileSendResponse.sentToInsureSign ? (
                  <Space size="small" direction="vertical" style={{ marginBottom: '10px' }}>
                    {fileSendResponse.sentToInsureSignResponseMessages.map((mes, index) => (
                      <Fragment key={'sentToInsureSign-fragment' + index}>
                        <Text key={'sentToInsureSign' + index} type={mes.isSuccess ? 'success' : 'danger'}>
                          <b>{noOfFilesSend++}. </b> {mes.message}
                        </Text>
                        {mes.navigateUrl ? (
                          <a key={'sentToInsureSign-mes' + index} target="_blank" href={`${mes.navigateUrl}`}>
                            Go to Formstack
                          </a>
                        ) : null}
                      </Fragment>
                    ))}
                  </Space>
                ) : null}

                {fileSendResponse.sentToWeSignature ? (
                  <Space size="small" direction="vertical" style={{ marginBottom: '10px' }}>
                    {fileSendResponse.sentToWeSignatureResponseMessages.map((mes, index) => (
                      <Fragment key={'sentToWeSignature-fragment' + index}>
                        <Text key={'sentToWeSignature' + index} type={mes.isSuccess ? 'success' : 'danger'}>
                          <b>{noOfFilesSend++}. </b> {mes.message}
                        </Text>
                        {mes.navigateUrl ? (
                          <a key={'sentToWeSignature-mes' + index} target="_blank" href={`${mes.navigateUrl}`}>
                            Go to We Signature
                          </a>
                        ) : null}
                      </Fragment>
                    ))}
                  </Space>
                ) : null}

                {fileSendResponse.sentToRabbitSign ? (
                  <Space size="small" direction="vertical" style={{ marginBottom: '10px' }}>
                    {fileSendResponse.sentToRabbitSignResponseMessages.map((mes, index) => (
                      <Text key={'sentToWeSignature' + index} type={mes.isSuccess ? 'success' : 'danger'}>
                        <b key={'sentToWeSignature-b-' + index}>{noOfFilesSend++}. </b> {mes.message}
                      </Text>
                    ))}
                  </Space>
                ) : null}

                {!fileSendResponse.sentToWeSignature &&
                  !fileSendResponse.sentToInsureSign &&
                  !fileSendResponse.sentToEmail &&
                  !fileSendResponse.sentToRabbitSign ? (
                  <Text>No files were attached</Text>
                ) : null}
              </div>
            ),
            onOk() {
              clearForm();
            },
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleRemoveFile = (file) => {
    setLocalSelectedFiles((prev) => prev.filter((f) => f.id !== file.id));
  };

  const handleClearFiles = () => {
    setLocalSelectedFiles([]);
  };

  const handleSave = () => {
    if (loading) {
      return;
    }

    sendFileFromRef
      .validateFields()
      .then((values) => {
        if (values.isRabbitSignChecked && !(isArray(rabbitSignFieldSettings) && rabbitSignFieldSettings.length > 0)) {
          Modal.error({
            getContainer: rootContainer,
            title:
              'You have selected RabbitSign but have not configured any fields. Please click on the edit fields button next to the RabbitSign checkbox.',
          });

          return;
        }

        if (sendFileInfo.canUseFormStack && values.isFormStackChecked) {
          const insuredSignLoginWindow = window.open(sendFileInfo.formStackSignInUrl, '_blank', 'width=600,height=400');

          insuredSignLoginWindow.focus();

          localStorage.removeItem('formstack_login_result');

          const loginResultListener = (ev) => {
            if (ev.key == 'formstack_login_result') {
              window.removeEventListener('storage', loginResultListener);

              const message = JSON.parse(ev.newValue);

              if (message && message.isSuccess) {
                submitFormData(values);
              }
            }
          };

          window.addEventListener('storage', loginResultListener);

          return;
        }

        submitFormData(values);
      })
      .catch((err) => {
        throw err;
      });
  };

  const clearForm = () => {
    sendFileFromRef.resetFields();
    setSendToSignServiceCheckedFirstTime(false);
    setShowEmailControls(true);
    setShowEmailControlsForFormstack(false);
    setShowEmailControlsForWeSign(false);
    setShowEmailControlsForRabbitSign(false);
    setShowRabbitSignSettings(false);
    setRabbitSignFieldSettings([]);
    setShowFaxControls(false);
    setShowCoverPageControls(false);
    setShowCcControls(false);
    setShowBccControls(false);
    setIncludePaymentSystemLinkCurrent('');
    setIsSendAsSmsApplied(false);

    tinymce?.activeEditor?.setContent('');
  };

  const handlePaymentSystemLinkRadioClick = (e) => {
    let updFieldValue = e.target.value;

    if (updFieldValue === includePaymentSystemLinkCurrent) {
      sendFileFromRef.setFieldsValue({
        includePaymentSystemLink: null,
      });

      updFieldValue = '';
    }

    setIncludePaymentSystemLinkCurrent(updFieldValue);
  };

  const setSendFormCallback = () => {
    if (typeof sendFormCallback === 'function') {
      sendFormCallback(() => {
        return {
          onClick: () => handleSave(),
          disabled:
            !showEmailControlsForFormstack &&
            !showEmailControlsForWeSign &&
            !showEmailControlsForRabbitSign &&
            !showEmailControls &&
            !showFaxControls,
        };
      });

      return true;
    }

    return false;
  };

  const handleCombineAllPdfsIntoOneChanged = (checked) => {
    if (checked) {
      let fileName = '';
      Modal.confirm({
        getContainer: rootContainer,
        width: 450,
        title: 'Combined file name',
        content: (
          <Input
            placeholder="Please enter or leave empty to use default value"
            defaultValue={combinedFileName}
            onChange={(e) => {
              fileName = e.target.value;
            }}
          />
        ),
        okText: 'OK',
        onOk: () => {
          setCombinedFileName(fileName);
        },
        cancelButtonProps: { style: { display: 'none' } },
      });
    }

    clearRabbitSignFieldSettings();
  };

  const handlePhoneBookContactSelected = (emails, fax) => {
    if (emails?.length) {
      let currentEmails = sendFileFromRef.getFieldValue('emailAddresses');

      if (!currentEmails) {
        currentEmails = [];
      }

      currentEmails = [...currentEmails, ...emails].filter((value, index, self) => self.indexOf(value) === index);

      sendFileFromRef.setFieldsValue({
        emailAddresses: currentEmails,
      });

      setRabbitSignersFromArray(currentEmails);
    }

    if (fax) {
      sendFileFromRef.setFieldsValue({
        fax: fax,
      });
    }
  };

  const handleFormStackCheckedChange = (checked) => {
    if (!sendToSignServiceCheckedFirstTime) {
      setShowEmailControls(false);

      sendFileFromRef.setFieldsValue({
        isSendEmailChecked: false,
      });
    }

    setShowEmailControlsForFormstack(checked);
    setSendToSignServiceCheckedFirstTime(true);
  };

  const handleWeSignCheckedChange = (checked) => {
    if (!sendToSignServiceCheckedFirstTime) {
      setShowEmailControls(false);

      sendFileFromRef.setFieldsValue({
        isSendEmailChecked: false,
      });
    }

    setShowEmailControlsForWeSign(checked);
    setSendToSignServiceCheckedFirstTime(true);
  };

  const handleRabbitSignCheckedChange = (checked) => {
    if (!sendToSignServiceCheckedFirstTime) {
      setShowEmailControls(false);

      sendFileFromRef.setFieldsValue({
        isSendEmailChecked: false,
      });
    }

    setSendToSignServiceCheckedFirstTime(true);

    if (checked) {
      sendFileFromRef.setFieldsValue({
        isRabbitSignChecked: false,
      });

      dispatch(rabbitActions.validateRabbitSignSubscription())
        .then((res) => {
          if (res.isRabbitSignSubscribed) {
            setShowEmailControlsForRabbitSign(true);

            sendFileFromRef.setFieldsValue({
              isRabbitSignChecked: true,
            });
          } else {
            clearRabbitSignFieldSettings();

            Modal.confirm({
              closable: true,
              getContainer: rootContainer,
              width: 450,
              title: 'Rabbit Sign Subscription',
              content: (
                <p>
                  {' '}
                  Your Rabbit Sign subscription has expired. Please renew your subscription{' '}
                  <a target="_blank" href={res.subscriptionUrl}>
                    here.
                  </a>
                </p>
              ),
              onOk: () => {
                window.open(res.subscriptionUrl, '_blank');
              },
            });
          }
        })
        .catch((error) => {
          console.error(error);
          clearRabbitSignFieldSettings();
        });
    } else {
      clearRabbitSignFieldSettings();
    }
  };

  const handleRabbitSignOpenFieldSettings = (e) => {
    setEnabledTemplates(true);

    setShowRabbitSignSettings(true);
  };

  const clearRabbitSignFieldSettings = (e) => {
    sendFileFromRef.resetFields(['isRabbitSignChecked']);

    if (!showEmailControlsForWeSign && !showEmailControlsForFormstack) {
      sendFileFromRef.setFieldsValue({
        isSendEmailChecked: true,
      });

      setShowEmailControls(true);
    }

    setShowRabbitSignSettings(false);
    setRabbitSignFieldSettings([]);
    setShowEmailControlsForRabbitSign(false);

    if (isArray(rabbitSignFieldSettings) && rabbitSignFieldSettings.length > 0) {
      notification.info({
        message: 'RabbitSign',
        top: 55,
        duration: 10,
        getContainer: rootContainer,
        description: 'RabbitSign settings have been cleaned up due to recent changes. Fields parameters must be set.',
      });
    }
  };

  const handleRabbitSignCloseFieldSettings = () => {
    setShowRabbitSignSettings(false);
  };

  const handleSendEmailCheckedChange = (checked) => {
    setShowEmailControls(checked);
  };

  const handleSendAsSmsChange = (checked) => {
    if (checked) {
      dispatch(smsActions.getMessageControlParameters())
        .then((resMessageControlParameters) => {
          if (
            resMessageControlParameters &&
            isString(resMessageControlParameters.errorMessage) &&
            !isEmpty(resMessageControlParameters.errorMessage)
          ) {
            Modal.error({
              getContainer: rootContainer,
              title: resMessageControlParameters.errorMessage,
            });

            resMessageControlParameters.errorMessage = undefined;

            sendFileFromRef.resetFields(['sendSms']);
            setIsSendAsSmsApplied(false);
          } else {
            setIsSendAsSmsApplied(checked);

            if (checked) {
              const insuredId = window['ncFileManager']['insuredId'];
              let contactId = null;
              let ownerType = null;

              if (isGuid(insuredId)) {
                contactId = insuredId;
                ownerType = 0;
              } else if (isGuid(sendFileInfo.agentId)) {
                contactId = sendFileInfo.agentId;
                ownerType = 1;
              } else if (isGuid(sendFileInfo.insuranceAgencyId)) {
                contactId = sendFileInfo.insuranceAgencyId;
                ownerType = 2;
              }

              if (contactId) {
                dispatch(smsActions.getContactPhones({ contactId: contactId, noteOwnerType: ownerType }));
              }
            }
          }
        })
        .catch((error) => {
          sendFileFromRef.resetFields(['sendSms']);
          setIsSendAsSmsApplied(false);
        });
    } else {
      sendFileFromRef.resetFields(['sendSms']);
      sendFileFromRef.resetFields(['insuredsPhone']);
      setIsSendAsSmsApplied(false);
    }
  };

  const handleInsuredsPhoneChange = (value) => {
    if (!messageControlParameters) {
      sendFileFromRef.resetFields(['insuredsPhone']);
    }

    dispatch(
      smsActions.checkExistedChat({
        toNumber: value.replace('+1', '').replace(/\D/g, ''),
        smsServiceType: messageControlParameters.smsServiceType,
        ownerAccountUserId: messageControlParameters.ownerAccountUserId,
        myPhoneNumber: messageControlParameters.myNumber,
      }),
    ).catch((error) => {
      sendFileFromRef.resetFields(['insuredsPhone']);
    });
  };

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  return !isMounted && (loading || isEmpty(sendFileInfo)) ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        minHeight: '300px',
      }}
    >
      <Space size="middle" align="center">
        <Spin size="default" />
      </Space>
    </div>
  ) : (
    <>
      <Form
        {...formItemLayout}
        form={sendFileFromRef}
        style={{
          maxHeight: '400px',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '10px 20px',
        }}
        layout="horizontal"
        name="sendFiles"
        size="small"
        labelAlign="left"
        initialValues={{
          isSendEmailChecked: showEmailControls,
          isSendFaxChecked: showFaxControls,
          isSendCcChecked: showCcControls,
          isSendBccChecked: showBccControls,
          cc: '',
          from: sendFileInfo.mainFromEmail ? sendFileInfo.mainFromEmail : '',
          subject: sendFileInfo.subject,
          messageTemplates: [],
          fax: sendFileInfo.faxNumber,
          isAddCoverPageChecked: showCoverPageControls,
          emailAddresses: sendFileInfo.mainToEmail ? [sendFileInfo.mainToEmail] : [],
          bcc: '',
          isSendCcToMe: false,
          isFormStackChecked: false,
          isWeSignChecked: false,
          isRabbitSignChecked: false,
          weSignSigType: 2, // They are signing
          combineAllPdfsIntoOne: false,

          includePaymentSystemLink: '',
          sendSms: false,
        }}
        id="send-file-form"
        disabled={loading}
      >
        <Row gutter={18}>
          <Col span={12}>
            <Form.Item label="Subject" labelCol={{ span: 3 }} wrapperCol={{ span: 21 }}>
              <Row gutter={8}>
                <Col span={16}>
                  <Form.Item name="subject" noStyle>
                    <Input placeholder="Please enter" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="combineAllPdfsIntoOne" valuePropName="checked" noStyle>
                    <div>
                      <Checkbox className="send-file-checkbox" onChange={(e) => handleCombineAllPdfsIntoOneChanged(e.target.checked)}>
                        Combine PDFs
                      </Checkbox>
                      <Tooltip title="Combines all PDFs into one when sending. Other file types may be skipped." getPopupContainer={rootContainer}>
                        {icons.question}
                      </Tooltip>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item noStyle>
              <Spin spinning={messageEditorLoading}>
                <div id={mceEditorId}></div>
              </Spin>
            </Form.Item>

            {receiptId && insuredId && !receiptIsCustomerAccountStatement ? (
              <div>
                <Divider type="horizontal" orientation="left" plain>
                  Include payment system link
                </Divider>

                <Form.Item name="includePaymentSystemLink" noStyle>
                  <div style={{ marginRight: '10px' }}>
                    <Radio.Group name="includePaymentSystemLink" size="small" buttonStyle="solid" value={includePaymentSystemLinkCurrent}>
                      <Radio.Button
                        value={'includeIntegrityLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isIntegrityEnabled}
                      >
                        <span style={{ marginRight: '5px' }}>Integrity</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for Integrity. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>

                      <Radio.Button
                        value={'includeEPayPolicyLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isEPayPolicyEnabled}
                      >
                        <span style={{ marginRight: '5px' }}>ePayPolicy</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for ePayPolicy. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>

                      <Radio.Button
                        value={'includeSimplyEasierPaymentsLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isSimplyEasierPaymentsEnabled}
                      >
                        <span style={{ marginRight: '5px' }}>Simply Easier Payments</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for Simply Easier Payments. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>

                      <Radio.Button
                        value={'includeTranzPayPaymentsLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isTranzPayPaymentsEnabled}
                      >
                        <span style={{ marginRight: '5px' }}>TranzPay Payments</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for TranzPay. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>

                      <Radio.Button
                        value={'includePayPalLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isPayPalEnabled}
                      >
                        <span style={{ marginRight: '5px' }}>PayPal</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for PayPal. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>

                      <Radio.Button
                        value={'includeInput1PaymentLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isInput1Enabled}
                      >
                        <span style={{ marginRight: '5px' }}>Input 1</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for Input 1. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>

                      <Radio.Button
                        value={'includeAscendPaymentLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isAscendEnabled}
                      >
                        <span style={{ marginRight: '5px' }}>Ascend</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for Ascend. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>

                      <Radio.Button
                        value={'includeAgavePaymentLink'}
                        onClick={(e) => handlePaymentSystemLinkRadioClick(e)}
                        disabled={!sendFileInfo?.isAgaveEnabled}
                      >
                        <span style={{ marginRight: '5px' }}>Agave</span>
                        <Tooltip
                          title="Enabled only if you have the correct settings for Agave. When checked, a link where the client will be able to pay the invoice will be sent."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                </Form.Item>
              </div>
            ) : null}
          </Col>

          <Col span={12}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '13px' }}>
              <div style={{ display: 'flex' }}>
                <div className="signature-checkboxes">
                  {sendFileInfo?.canUseFormStack && !receiptId ? (
                    <Form.Item noStyle name="isFormStackChecked" valuePropName="checked">
                      <div style={{ marginRight: '10px' }}>
                        <Checkbox
                          className="send-file-checkbox"
                          disabled={!sendFileInfo?.isFormStackEnabled || loading}
                          onChange={(e) => handleFormStackCheckedChange(e.target.checked)}
                        >
                          Formstack Sign
                        </Checkbox>
                        <Tooltip
                          title="Enabled only if you have a Formstack Sign account (Agency/Agent profile). When checked, an email is sent to the specified addresses with the option to sign the document with InsureSign."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </div>
                    </Form.Item>
                  ) : null}

                  {sendFileInfo?.isRabbitSignEnabled && !receiptId ? (
                    <Form.Item noStyle name="isRabbitSignChecked" valuePropName="checked">
                      <div style={{ marginRight: '10px' }}>
                        <Checkbox
                          className="send-file-checkbox"
                          disabled={validateRabbitSignSubscriptionLoading || loading}
                          onChange={(e) => handleRabbitSignCheckedChange(e.target.checked)}
                        >
                          {validateRabbitSignSubscriptionLoading ? (
                            <Spin spinning={validateRabbitSignSubscriptionLoading}>Rabbit Sign</Spin>
                          ) : (
                            'Rabbit Sign'
                          )}
                        </Checkbox>

                        {showEmailControlsForRabbitSign === true ? (
                          <Button onClick={($event) => handleRabbitSignOpenFieldSettings($event)}>Assign Fields</Button>
                        ) : null}

                        {showRabbitSignSettings === true ? (
                          <FieldSettingsModal
                            rootContainer={rootContainer}
                            open={showRabbitSignSettings}
                            onCancel={() => handleRabbitSignCloseFieldSettings()}
                            setRabbitSignFieldSettings={(fields) => setRabbitSignFieldSettings(fields)}
                            enabledTemplates={enabledTemplates}
                            rabbitSignFieldSettings={rabbitSignFieldSettings}
                            selectedFiles={localSelectedFiles
                              .filter((f) => f.type === 'file')
                              .map((f, index) => {
                                return { id: f.id, order: !f.order && !f.order >= 0 ? index : f.order };
                              })}
                            emails={orderBy(rabbitSigners, ['nonRequiredToSign', 'contactType'], ['desc', 'asc']).map((obj, index) => {
                              obj.signerLabel = 'Client ' + (index + 1);
                              obj.signerColor = getSignerColor(index);

                              return obj;
                            })}
                            setSignersOrder={(items) => setRabbitSigners(items)}
                            combineAllPdfsIntoOne={sendFileFromRef.getFieldValue('combineAllPdfsIntoOne')}
                          />
                        ) : null}
                      </div>
                    </Form.Item>
                  ) : null}
                </div>

                {sendFileInfo?.canUseWeSign && !receiptId ? (
                  <div style={{ display: 'flex', flexDirection: 'column', marginRight: '10px' }}>
                    <Form.Item noStyle name="isWeSignChecked" valuePropName="checked">
                      <div>
                        <Checkbox
                          className="send-file-checkbox"
                          disabled={!sendFileInfo?.isWeSignEnabled || loading}
                          onChange={(e) => handleWeSignCheckedChange(e.target.checked)}
                        >
                          We Signature
                        </Checkbox>
                        <Tooltip
                          title="Enabled only if you have a We Signature account (Agency/Agent profile). When checked, an email is sent to the specified addresses with the option to sign the document with We Signature."
                          getPopupContainer={rootContainer}
                        >
                          {icons.question}
                        </Tooltip>
                      </div>
                    </Form.Item>

                    {showEmailControlsForWeSign ? (
                      <Form.Item noStyle label="We Signature Type" name="weSignSigType">
                        <Select showArrow placeholder="Please select" getPopupContainer={() => document.getElementById('send-file-form')}>
                          <Select.Option value={0}>I am signing</Select.Option>
                          <Select.Option value={1}>We are signing</Select.Option>
                          <Select.Option value={2}>They are signing</Select.Option>
                        </Select>
                      </Form.Item>
                    ) : null}
                  </div>
                ) : null}

                <div className="send-email-checkboxes">
                  <Form.Item name="isSendEmailChecked" valuePropName="checked" noStyle>
                    <Checkbox className="send-file-checkbox" onChange={(e) => handleSendEmailCheckedChange(e.target.checked)}>
                      Send email
                    </Checkbox>
                  </Form.Item>

                  {showEmailControls || showEmailControlsForFormstack || showEmailControlsForWeSign || showEmailControlsForRabbitSign ? (
                    <Form.Item name="isSendCcToMe" valuePropName="checked" noStyle>
                      <Checkbox className="send-file-checkbox">Send CC to Me</Checkbox>
                    </Form.Item>
                  ) : null}
                </div>
              </div>

              <PhoneBookModal
                rootContainer={rootContainer}
                insuredId={window['ncFileManager']['insuredId']}
                policyId={window['ncFileManager']['policyId']}
                onContactSelected={(emails, fax) => handlePhoneBookContactSelected(emails, fax)}
              />
            </div>

            {showEmailControls || showEmailControlsForFormstack || showEmailControlsForWeSign || showEmailControlsForRabbitSign ? (
              <>
                <Form.Item label="From" name="from">
                  <Select
                    showArrow
                    allowClear
                    placeholder="Please select"
                    getPopupContainer={() => document.getElementById('send-file-form')}
                    onChange={(item) => handleFromEmailChange(item)}
                  >
                    {getSelectFromEmailOptions()}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="To"
                  name="emailAddresses"
                  rules={[
                    {
                      pattern: /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/,
                      message: 'Please specify valid email addresses',
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showArrow
                    mode="tags"
                    tagRender={tagRender}
                    placeholder="Please select"
                    onChange={(item) => handleToEmailChange(item)}
                    getPopupContainer={() => document.getElementById('send-file-form')}
                  >
                    {sendFileInfo && sendFileInfo.emails
                      ? sendFileInfo.emails.map((emailInfo, index) => (
                        <Select.Option
                          value={emailInfo.email}
                          key={'to-' + index + '-' + emailInfo.email}
                          title={(emailInfo.name ? emailInfo.name + ' ' : '') + emailInfo.email}
                        >
                          {emailInfo.email}
                        </Select.Option>
                      ))
                      : null}
                  </Select>
                </Form.Item>
              </>
            ) : null}

            {showEmailControls || showEmailControlsForFormstack || showEmailControlsForWeSign || showEmailControlsForRabbitSign ? (
              <>
                <Form.Item name="isSendCcChecked" valuePropName="checked">
                  <Checkbox className="send-file-checkbox" onChange={(e) => setShowCcControls(e.target.checked)}>
                    Send CC
                  </Checkbox>
                </Form.Item>

                {showCcControls ? (
                  <>
                    <Form.Item
                      label="CC"
                      name="cc"
                      rules={[
                        {
                          required: true,
                          message: 'The CC field is required.',
                        },
                        () => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.resolve();
                            }

                            var emails = value.replace(/\s/g, '').split(',');

                            var valid = true;
                            var regex =
                              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                            for (var i = 0; i < emails.length; i++) {
                              if (emails[i] == '' || !regex.test(emails[i])) {
                                valid = false;
                              }
                            }

                            if (valid) {
                              return Promise.resolve();
                            }

                            return Promise.reject(new Error('The input must be a valid emails separated with comma.'));
                          },
                        }),
                      ]}
                    >
                      <Input placeholder="Please enter" />
                    </Form.Item>
                  </>
                ) : null}

                <Form.Item name="isSendBccChecked" valuePropName="checked">
                  <Checkbox className="send-file-checkbox" onChange={(e) => setShowBccControls(e.target.checked)}>
                    Send BCC
                  </Checkbox>
                </Form.Item>

                {showBccControls ? (
                  <>
                    <Form.Item
                      label="BCC"
                      name="bcc"
                      rules={[
                        {
                          required: true,
                          message: 'The BCC field is required.',
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid email.',
                        },
                      ]}
                    >
                      <Input placeholder="Please enter" />
                    </Form.Item>
                  </>
                ) : null}
              </>
            ) : null}

            <div style={{ display: 'flex' }}>
              <Form.Item name="isSendFaxChecked" valuePropName="checked" noStyle>
                <Checkbox className="send-file-checkbox" onChange={(e) => setShowFaxControls(e.target.checked)} style={{ marginRight: '20px' }}>
                  Send Fax
                </Checkbox>
              </Form.Item>

              {showFaxControls ? (
                <Form.Item
                  label="Fax"
                  name="fax"
                  style={{ flex: 1 }}
                  rules={[
                    {
                      required: true,
                      message: 'The fax field is required.',
                    },
                    {
                      pattern: /\d{3}-\d{3}-\d{4}/,
                      message: 'You must input all digits of fax number',
                    },
                  ]}
                >
                  <InputMask mask="999-999-9999" placeholder="___-___-____"></InputMask>
                </Form.Item>
              ) : null}
            </div>

            {showFaxControls ? (
              <div style={{ display: 'flex' }}>
                <Form.Item name="isAddCoverPageChecked" valuePropName="checked" noStyle>
                  <Checkbox
                    className="send-file-checkbox"
                    onChange={(e) => setShowCoverPageControls(e.target.checked)}
                    style={{ marginRight: '49px' }}
                  >
                    Add Cover Page
                  </Checkbox>
                </Form.Item>

                {showCoverPageControls ? (
                  <Form.Item name="coverPage">
                    <CoverPageComponent rootContainer={rootContainer} newInterfaceUsing={true} />
                  </Form.Item>
                ) : null}
              </div>
            ) : null}

            <div style={{ display: 'flex', marginTop: '13px' }}>
              <Form.Item name="sendSms" valuePropName="checked" noStyle>
                <Checkbox className="send-file-checkbox" onChange={(e) => handleSendAsSmsChange(e.target.checked)} style={{ marginRight: '20px' }}>
                  <Spin spinning={messageControlParametersLoading === true}>Send as SMS</Spin>
                </Checkbox>
              </Form.Item>

              {isSendAsSmsApplied ? (
                <Form.Item
                  name={['insuredsPhone']}
                  initialValue={null}
                  rules={[{ required: true, message: 'This field is required.' }]}
                  style={{ flex: 1 }}
                >
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.title.toLowerCase().includes(input.toLowerCase())}
                    loading={contactPhonesLoading}
                    getPopupContainer={() => document.getElementById('send-file-form')}
                    placeholder="Type and/or choose insured's phone"
                    notFoundContent={renderNoDataOrSpinner(contactPhonesLoading)}
                    onChange={handleInsuredsPhoneChange}
                  >
                    {contactPhones && contactPhones.length
                      ? contactPhones.map((option) => (
                        <Select.Option
                          value={option.text}
                          key={option.value}
                          title={option.typeString + ' (' + option.text + ') - ' + option.display}
                        >
                          <strong>
                            {option.typeString} ({option.text}) - {option.display}
                          </strong>
                        </Select.Option>
                      ))
                      : null}
                  </Select>
                </Form.Item>
              ) : null}
            </div>
          </Col>
        </Row>
      </Form>

      {!isSendFormBtnFromOutside ? (
        <>
          <div style={{ padding: '10px 24px' }}>
            <SelectedFilesList
              selectedFiles={localSelectedFiles}
              rootContainer={rootContainer}
              onRemoveFile={handleRemoveFile}
              onClearFiles={handleClearFiles}
            />
          </div>

          <Divider style={{ margin: '0' }} />

          <div
            style={{
              padding: '16px 24px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            {!inlineRenderMode ? (
              <Button style={{ marginRight: '10px' }} onClick={onHide}>
                Cancel
              </Button>
            ) : null}

            <Button
              loading={loading}
              type="primary"
              onClick={() => handleSave()}
              disabled={
                (!showEmailControlsForFormstack &&
                  !showEmailControlsForWeSign &&
                  !showEmailControlsForRabbitSign &&
                  !showEmailControls &&
                  !showFaxControls &&
                  !isSendAsSmsApplied &&
                  !contactPhonesLoading &&
                  !messageControlParametersLoading) ||
                loading
              }
            >
              Send
            </Button>
          </div>
        </>
      ) : null}
    </>
  );
};

export default hot(withErrorHandler(SendFileForm, axios, root, newAxios));
